import React, { useState, useEffect } from 'react'
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";

import {
  Row,
  Divider,
  Form,
  Spin,
  Col,
  Select,
  Typography,
  Button,
  Modal,
  Collapse,
  Table,
  Tooltip
} from "antd";
import cnt from "../../../../services/definedConstant"
import { BOM } from "../../../../services/definedMethod";
import { apiConfig, labelConfig } from "../../group.config";
import styles from '../../../../assets/styles/styles';
import Notiflix from "notiflix";

const { Text, Title } = Typography
const { Panel } = Collapse;


const Committee = (props) => {
  const { state, session, groupRolesList, setGroupRolesList } = props;
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const handleUnassignRole = (key) => {
    let action = "Unassign ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const params = {
          command: "unassignRole",
          roleId: key.id
        }

        const url = `${apiConfig.Groups}/${state.id}`;

        const body = {
          method: "POST",
          session,
          params
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            setIsLoading(false);
          } else {
            const newData = groupRolesList.filter((item) => item.id !== key.id);
            setGroupRolesList(newData);
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.unassignRoleMsg);

            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: "Role",
      dataIndex: "role",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Client ID",
      dataIndex: "clientId",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        groupRolesList.length >= 1 ? (
          BOM.HasPermission("UNASSIGNROLE_GROUP") &&
          <Tooltip title={`Unassign`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleUnassignRole(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ]

  return (
    <>
      <Row >
        <AddRole
          useForm={useForm}
          session={session}
          state={state}
          setGroupRolesList={setGroupRolesList}
          groupRolesList={groupRolesList}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />

        {groupRolesList?.length > 0 && (
          <>
            <Divider orientation="left" orientationMargin="0"></Divider>
            <Col span={24}>
              <Table
                columns={columns}
                dataSource={groupRolesList}
                bordered
                pagination={{
                  position: "bottomCentre",
                  pageSize: "10",
                }}
              />
            </Col>
          </>
        )}
      </Row>
    </>
  )
}

export default Committee


const AddRole = (props) => {

  const { useForm, session, state, groupRolesList, setGroupRolesList, isLoading, setIsLoading } = props
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clientOptions, setClientOptions] = useState([]);
  const [rolesOptions, setRolesOptions] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    getRoleTemplate()
  }, []);

  const getRoleTemplate = () => {

    const params = {
      associations: "all",
      template: true,
    }
    const url = `${apiConfig.Groups}/${state.id}`;

    let body = {
      session,
      params
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;

        let tempClientsArray = []
        let tempRolesArray = []

        objDetail?.clientMembers?.forEach((element) => {
          tempClientsArray.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objDetail?.availableRoles?.forEach((element) => {
          tempRolesArray.push({
            value: element.id,
            label: element.name,
          });
        });

        setClientOptions(tempClientsArray);
        setRolesOptions(tempRolesArray);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };


  const onSubmitRole = (formValues) => {

    const clientObj = clientOptions.find((item) => item.value === formValues.clientId)
    const roleObj = rolesOptions.find((item) => item.value === formValues.role)

    const params = {
      command: "assignRole",
    }

    const url = `${apiConfig.Groups}/${state.id}`;

    const body = {
      ...formValues,
      method: "POST",
      session,
      params
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);

      } else {
        const newRole = {
          key: count,
          id: res?.resourceId,
          name: clientObj.label,
          role: roleObj.label,
          clientId: formValues.clientId,
        };

        setGroupRolesList([...groupRolesList, newRole]);
        setCount(count + 1);

        BOM.AlertMsg(cnt.SUCCESS, labelConfig.newRoleMsg);

        setIsModalOpen(false);

        useForm.resetFields();

        //STOP LOAD
        setIsLoading(false);
      }
    });

  };

  return (
    <>
      {BOM.HasPermission("ASSIGNROLE_GROUP") && <Button type="primary" shape="round" className="of-primaryBtnColor" onClick={showModal}>
        <PlusCircleOutlined />
        &nbsp;{labelConfig.add}
      </Button>}
      <Modal
        title="Add Role"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={useForm}
            onFinish={onSubmitRole}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Saving..." size="large">

          <Divider />

          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>{labelConfig.client}</Text>}
                name={"clientId"}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  showSearch
                  options={clientOptions}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.client,
                    "select"
                  )}
                  allowClear
                />
              </Form.Item>
            </Col>

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>{labelConfig.role}</Text>}
                name={"role"}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  showSearch
                  options={rolesOptions}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.role,
                    "select"
                  )}
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};
